/**
 * Toast notification component
 */

/**
 * Show a toast notification
 * @param {string} message - The message to display
 * @param {string} type - Notification type: 'info', 'success', 'error', 'warning'
 * @param {number} duration - Duration in milliseconds (default: 5000)
 */
export function showNotification(message, type = 'info', duration = 5000) {
    const notification = document.createElement('div');

    // Map type to CSS variable color
    const colorMap = {
        success: 'var(--success)',
        error: 'var(--error)',
        warning: 'var(--warning, #f39c12)',
        info: 'var(--info, #3498db)'
    };

    notification.style.cssText = `
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: ${colorMap[type] || colorMap.info};
        color: white;
        padding: 1rem 1.5rem;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        z-index: 10001;
        animation: slideIn 0.3s ease-out;
        max-width: 400px;
        word-wrap: break-word;
    `;

    notification.textContent = message;
    document.body.appendChild(notification);

    setTimeout(() => {
        notification.style.animation = 'slideOut 0.3s ease-out';
        setTimeout(() => notification.remove(), 300);
    }, duration);

    return notification;
}

/**
 * Show a success notification
 */
export function showSuccess(message, duration = 5000) {
    return showNotification(message, 'success', duration);
}

/**
 * Show an error notification
 */
export function showError(message, duration = 5000) {
    return showNotification(message, 'error', duration);
}

/**
 * Show an info notification
 */
export function showInfo(message, duration = 5000) {
    return showNotification(message, 'info', duration);
}

/**
 * Show a warning notification
 */
export function showWarning(message, duration = 5000) {
    return showNotification(message, 'warning', duration);
}
